import { useMemo } from "react";
import { useAppSelector } from "../../../app/hooks";
import { Image } from "../../../common/interfaces/ProductDetailsDataInterface";
import { CategoryInterface } from "../../../common/interfaces/CategoryInterface";
import {
    DstAssociationCard,
    DstProductDetailViewModel,
} from "../interfaces/ProductDetailViewTypes";
import {
    mapDstAssociationsForSliders,
    mapDstProductToViewModel,
} from "../utils/dstProductDetailAdapters";

export interface UseDstProductDetailDataResult {
    viewModel: DstProductDetailViewModel | undefined;
    accessories: DstAssociationCard[];
    similarProducts: DstAssociationCard[];
    localImages: Image[];
    productCategories: CategoryInterface[];
    isLoading: boolean;
    isNotFound: boolean;
    isAssociationsLoading: boolean;
}

export const useDstProductDetailData = (): UseDstProductDetailDataResult => {
    const {
        data,
        productAssociations,
        productImages,
        productCategories,
        localImages,
        isLoading,
        isNotFound,
    } = useAppSelector((state) => state.productDetails);

    const viewModel = useMemo(
        () => (data ? mapDstProductToViewModel(data) : undefined),
        [data],
    );

    const { accessories, similarProducts } = useMemo(
        () => mapDstAssociationsForSliders(productAssociations, productImages),
        [productAssociations, productImages],
    );

    return {
        viewModel,
        accessories,
        similarProducts,
        localImages,
        productCategories,
        isLoading,
        isNotFound,
        isAssociationsLoading: isLoading,
    };
};
